import React, { useEffect, useState } from "react";
import "../styles/DashHome.css";

const DashHome = () => {
  const [dashboardData, setDashboardData] = useState({
    total_clientes: 0,
    ultimos_clientes: []
  });

  const [noticias, setNoticias] = useState([]);

  useEffect(() => {
    fetch("http://localhost:5000/api/clientes/dashboard/info")
      .then((res) => res.json())
      .then((data) => setDashboardData(data))
      .catch((err) => console.error("Erro ao buscar dados do dashboard:", err));

    fetch("http://localhost:5000/api/noticias")
      .then((res) => res.json())
      .then((data) => setNoticias(data))
      .catch((err) => console.error("Erro ao buscar notícias:", err));
  }, []);

  return (
    <div className="dashboard-container">
      <h1>Bem-vindo ao The Simon Project</h1>
      <p className="welcome">Veja abaixo os dados mais recentes do sistema.</p>

      <div className="dashboard-grid">
        <div className="dashboard-card">
          <h2>Total de Clientes</h2>
          <p className="numero">{dashboardData.total_clientes}</p>
        </div>

        <div className="dashboard-card">
          <h2>Últimos Clientes Cadastrados</h2>
          <ul>
            {Array.isArray(dashboardData.ultimos_clientes) &&
              dashboardData.ultimos_clientes.map((cliente) => (
                <li key={cliente.id}>
                  <strong>{cliente.razao_social}</strong><br />
                  {cliente.telefone} | {cliente.website}
                </li>
              ))}
          </ul>
        </div>

        <div className="dashboard-card">
          <h2>Notícias do Setor Educacional</h2>
          <ul>
            {Array.isArray(noticias) &&
              noticias.map((noticia, index) => (
              <li key={index}>
                <a href={noticia.link} target="_blank" rel="noopener noreferrer">
                  {noticia.titulo}
                </a>
                <br />
                <small>{noticia.publicado}</small>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DashHome;